import type { DateValue } from "react-aria-components";
import dayjs from "dayjs";

import DashIcon from "@/assets/images/icons2/icon--dash.svg?component";
import { DatePicker2 } from "@/ui2/organisms/DatePicker";
import { getCalendarDateFromDayjs } from "@/lib/helpers/getCalendarDateFromDayjs";

type DateRangeFilterProps = {
  dateEnd: DateValue;
  dateStart: DateValue;
  onDateEndChange: (date: DateValue) => void;
  onDateStartChange: (date: DateValue) => void;
};

/** Explicitly skip validation
 * The date is already constrained by minValue and maxValue.
 * Avoid showing an error message or invalid styling to prevent layout issues.
 */
const SKIP_VALIDATION = true;

export function DateRangeFilter({
  dateEnd,
  dateStart,
  onDateEndChange,
  onDateStartChange,
}: DateRangeFilterProps) {
  const now = dayjs();
  const todayCalendarDate = getCalendarDateFromDayjs(now);

  return (
    <div className="tw:flex tw:items-end tw:gap-3">
      <DatePicker2
        isInvalid={!SKIP_VALIDATION}
        label="From"
        maxValue={dateEnd ?? todayCalendarDate}
        onChange={onDateStartChange}
        value={dateStart}
      />
      <DashIcon className="tw:mb-5.5 tw:w-5 tw:text-text-quinary" />
      <DatePicker2
        isInvalid={!SKIP_VALIDATION}
        label="To"
        maxValue={todayCalendarDate}
        minValue={dateStart}
        onChange={onDateEndChange}
        value={dateEnd}
      />
    </div>
  );
}
